interface LoadingSparkleProps {
  message?: string;
}

export default function LoadingSparkle({ message = "Creating magic..." }: LoadingSparkleProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-6 py-12">
      <div className="relative w-20 h-20">
        {[0, 1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="absolute w-3 h-3 bg-accent rounded-full animate-sparkle"
            style={{
              top: `${50 + 40 * Math.sin((i * 2 * Math.PI) / 5) - 6}%`,
              left: `${50 + 40 * Math.cos((i * 2 * Math.PI) / 5) - 6}%`,
              animationDelay: `${i * 0.3}s`,
            }}
          />
        ))}
        <div className="absolute inset-4 bg-primary rounded-full animate-float opacity-80" />
      </div>
      <p className="font-heading font-bold text-lg text-dark/70">{message}</p>
    </div>
  );
}
